<template>
  <nav
    role="navigation"
    aria-label="main navigation"
    class="navbar has-background-light is-fixed-top"
    :style="{ backgroundColor: config.header_bgcolor}"
  >
    <!-- config button_bgcolor  -->
    <!-- {{ config }} -->
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item mt-2 img-wrap" @click="openLink('/')">
          <img
            v-if="config.logo"
            height="28"
            width="125"
            alt="KidsTopia"
            loading="lazy"
            fetchpriority="auto"
            :src="config.logo"
          />
        </a>
        <div
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasic"
          :class="isopen ? 'is-active navbar-burger' : 'navbar-burger'"
          @click="open"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </div>
      </div>
      <div
        id="navbarBasic"
        :class="isopen ? 'is-active navbar-menu' : 'navbar-menu'"
      >
        <div class="navbar-start">
          <template v-for="(item, index) in headerTabList">
            <div
              v-if="item.child && item.child.length"
              :key="index"
              class="navbar-item has-dropdown is-hoverable"
            >
              <a class="navbar-link" :style="{ color: config.title_color }" @click="openLink(item.path, item)">
                {{ item.title }}
              </a>
              <div class="navbar-dropdown">
                <a
                  class="navbar-item"
                  @click="openLink(citem.path, citem)"
                  v-for="(citem, cindex) in item.child"
                  :key="cindex"
                >
                  {{ citem.title }}
                </a>
              </div>
            </div>
            <a
              v-else
              class="navbar-item"
              :style="{ color: config.title_color }"
              @click="openLink(item.path, item)"
              :key="`a-${index}`"
            >
              {{ item.title }}
            </a>
          </template>
        </div>
        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable">
            <a
              class="navbar-link is-arrowless has-text-white has-text-weight-semibold has-background-primary"
              :style="{ backgroundColor : config.button_bgcolor}"
            >
              <img
                class="fas fa-map-marker-alt mr-2"
                src="../../assets/img/local.png"
              />
              Choose Location
            </a>
            <div class="navbar-dropdown">
              <a
                :href="`https://${item.domain}`"
                routerlinkactive="active"
                class="navbar-item has-text-primary has-text-weight-semibold"
                v-for="(item, index) in shopList"
                :key="index"
              >
                {{ item.name }}
              </a>
            </div>
          </div>
          <div class="navbar-item">
            <a
              v-if="config.fb_account"
              class="mr-4"
              @click="openOther(config.fb_account)"
            >
              <img
                height="28"
                width="28"
                alt="KidsTopia Facebook"
                loading="lazy"
                fetchpriority="auto"
                src="@/assets/img/logo-FB.png"
              />
            </a>
            <a
              v-if="config.instagram_account"
              @click="openOther(config.instagram_account)"
            >
              <img
                height="28"
                width="28"
                alt="KidsTopia Instagram"
                loading="lazy"
                fetchpriority="auto"
                src="@/assets/img/logo-INS.png"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import store from "@/store";
export default {
  components: {  },
  data() {
    return {
      name: null,
      active: false,
      isopen: false
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
    headerTabList() {
      return store.state.global.headerTabs || [];
    },
    shopList() {
      return store.state.global.shopLists || [];
    },
  },
  watch: {},
  created() {},
  methods: {
    // open modal
    open() {
      this.isopen = !this.isopen;
    },
    // open ig or facebook
    openOther(url) {
      window.open(`${url}/?from=web-nav`);
    },
    openLink(path, item) {
      var query = {};
      if (item && item.id && item.menu_type == 'page') query.id = item.id;
      this.$router.push({
        path: path,
        query: query
      });
    },
  },
};
</script>
<style scoped>
.fa {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}
.navbar {
  background-color: #fff;
  min-height: 3.25rem;
  position: relative;
  z-index: 30;
}
.has-background-light {
  background-color: #f5f5f5;
}
.navbar.is-fixed-bottom,
.navbar.is-fixed-top {
  left: 0;
  position: fixed;
  right: 0;
  z-index: 30;
}
.navbar.is-fixed-top {
  top: 0;
}
.navbar {
  box-shadow: 3px 3px 6px #d6d6d6;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.navbar > .container {
  align-items: stretch;
  display: flex;
  min-height: 3.25rem;
  width: 100%;
}
.navbar-brand,
.navbar-tabs {
  align-items: stretch;
  display: flex;
  flex-shrink: 0;
  min-height: 3.25rem;
}
a {
  color: #e55f61;
  cursor: pointer;
  text-decoration: none;
}
.navbar-item,
.navbar-link {
  color: #757763;
  display: block;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
}
.navbar-item {
  flex-grow: 0;
  flex-shrink: 0;
}
.navbar-item,
.navbar-link {
  color: #333;
}

a.navbar-item,
.navbar-link {
  cursor: pointer;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
img,
video {
  height: auto;
  max-width: 100%;
}
.img-wrap {
  height: 28px;
}
.navbar-item img {
  max-height: 1.75rem;
}
.navbar-burger {
  -webkit-appearance: none;
  appearance: none;
  background: none;
  border: none;
  color: currentColor;
  font-family: inherit;
  font-size: 1em;
  margin: 0;
  padding: 0;
}
.navbar-burger {
  color: #757763;
  -webkit-appearance: none;
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  height: 3.25rem;
  position: relative;
  width: 3.25rem;
  margin-left: auto;
}
.navbar-burger span:nth-child(1) {
  top: calc(50% - 6px);
}
.navbar-burger span:nth-child(2) {
  top: calc(50% - 1px);
}
.navbar-burger span:nth-child(3) {
  top: calc(50% + 4px);
}
span {
  font-style: inherit;
  font-weight: inherit;
}
.navbar-burger span {
  background-color: currentColor;
  display: block;
  height: 1px;
  left: calc(50% - 8px);
  position: absolute;
  transform-origin: center;
  transition-duration: 86ms;
  transition-property: background-color, opacity, transform;
  transition-timing-function: ease-out;
  width: 16px;
}
.navbar-menu {
  display: none;
}
.navbar-item,
.navbar-link {
  color: #757763;
  display: block;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
}
.navbar-item {
  flex-grow: 0;
  flex-shrink: 0;
}
.navbar-item.has-dropdown {
  padding: 0;
}
.navbar-item,
.navbar-link {
  color: #333;
}

.navbar-item,
.navbar-link {
  color: #757763;
  display: block;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
}
a.navbar-item,
.navbar-link {
  cursor: pointer;
}

.has-text-weight-semibold {
  font-weight: 600 !important;
}
.has-background-primary {
  background-color: #de4c50;
}
.has-text-white {
  color: #fff !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}

.fas,
.fa-solid {
  font-weight: 900;
}
.fas,
.fa-classic,
.fa-solid,
.far,
.fa-regular {
  font-family: "Font Awesome 6 Free";
}
.fa-map-marker-alt:before {
  content: "";
  background: url(../../assets/img/local_footer.jpg) no-repeat 50% / contain;
}
.navbar-dropdown {
  font-size: 0.875rem;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
.mr-4 {
  margin-right: 1rem !important;
}
.navbar-burger:hover {
  background-color: #0000000d;
}

a:hover {
  color: #363636;
}
.navbar-burger.is-active span:nth-child(1) {
  transform: translateY(5px) rotate(45deg);
}

.navbar-burger.is-active span:nth-child(2) {
  opacity: 0;
}

.navbar-burger.is-active span:nth-child(3) {
  transform: translateY(-5px) rotate(-45deg);
}
.has-dropdown {
  height: 100%;
}
.navbar-item.has-dropdown {
  padding: 0;
}
.navbar-link:not(.is-arrowless) {
  padding-right: 2.5em;
}
.navbar-item,
.navbar-link {
  color: #333;
}
.navbar-link:not(.is-arrowless):after,
.select:not(.is-multiple):not(.is-loading):after {
  border: 3px solid transparent;
  border-radius: 2px;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.625em;
  margin-top: -0.4375em;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: rotate(-45deg);
  transform-origin: center;
  width: 0.625em;
}
.navbar-link:not(.is-arrowless):after {
  border-color: #e55f61;
  margin-top: -0.375em;
  right: 1.125em;
  box-sizing: border-box;
}
.navbar-item:hover,
.navbar-link:hover {
  color: #222;
  font-weight: 600;
}
.navbar-link,
a.navbar-item {
  cursor: pointer;
}
.navbar-dropdown .navbar-item {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.navbar-item,
.navbar-link {
  color: #333;
}

.navbar-item:hover,
.navbar-link:hover {
  color: #222;
  font-weight: 600 !important;
}

.navbar-link.is-active,
.navbar-link:focus,
.navbar-link:focus-within,
.navbar-link:hover,
a.navbar-item.is-active,
a.navbar-item:focus,
a.navbar-item:focus-within,
a.navbar-item:hover {
   /** background-color: #fafafa; **/
}
@media screen and (max-width: 1023px) {
  .navbar-menu.is-active {
    display: block;
  }
  .navbar.is-fixed-top .navbar-menu,
  .navbar.is-fixed-top-touch .navbar-menu {
    -webkit-overflow-scrolling: touch;
    max-height: calc(100vh - 3.25rem);
    overflow: auto;
  }
  .navbar-menu {
    background-color: #fff;
    box-shadow: 0 8px 16px #0a0a0a1a;
    padding: 0.5rem 0;
  }
  .navbar > .container {
    display: block;
  }
}
.navbar-brand {
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .navbar {
    min-height: 3.25rem;
  }
  .container {
    max-width: 960px;
  }
  .navbar-item {
    align-items: center;
    display: flex;
  }
  .navbar-link {
    align-items: center;
    display: flex;
  }
  .navbar-burger {
    display: none;
  }
  .navbar-brand {
    width: auto;
  }
  .navbar,
  .navbar-menu,
  .navbar-start,
  .navbar-end {
    align-items: stretch;
    display: flex;
  }
  .navbar-menu {
    flex-grow: 1;
    flex-shrink: 0;
  }
  .navbar > .container .navbar-menu,
  .container > .navbar .navbar-menu {
    margin-right: -0.75rem;
  }
  .navbar > .container .navbar-brand,
  .container > .navbar .navbar-brand {
    margin-left: -0.75rem;
  }
  .navbar-start {
    justify-content: flex-start;
    margin-right: auto;
  }
  .navbar-end {
    justify-content: flex-end;
    margin-left: auto;
  }
  .navbar-item.has-dropdown {
    align-items: stretch;
  }
  .navbar-dropdown {
    background-color: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid hsl(0, 0%, 86%);
    box-shadow: 0 8px 8px #0a0a0a1a;
    display: none;
    font-size: 0.875rem;
    left: 0;
    min-width: 100%;
    position: absolute;
    top: 100%;
    z-index: 20;
  }
  .navbar,
  .navbar-end,
  .navbar-menu,
  .navbar-start {
    align-items: stretch;
    display: flex;
  }
  .navbar-start {
    justify-content: flex-start;
    margin-right: auto;
  }
  .navbar-item,
  .navbar-link {
    align-items: center;
    display: flex;
  }
  .navbar-item,
  .navbar-link {
    align-items: center;
    display: flex;
  }
  .navbar-item.has-dropdown {
    align-items: stretch;
  }
  .navbar-dropdown {
    background-color: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid #dbdbdb;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    display: none;
    font-size: 0.875rem;
    left: 0;
    min-width: 100%;
    position: absolute;
    top: 100%;
    z-index: 20;
  }
  .navbar-item.is-active .navbar-dropdown,
  .navbar-item.is-hoverable:focus-within .navbar-dropdown,
  .navbar-item.is-hoverable:focus .navbar-dropdown,
  .navbar-item.is-hoverable:hover .navbar-dropdown {
    display: block;
  }
  .navbar-dropdown {
    background-color: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 2px solid #dbdbdb;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    display: none;
    font-size: 0.875rem;
    left: 0;
    min-width: 100%;
    position: absolute;
    top: 100%;
    z-index: 20;
  }
  .navbar-dropdown a.navbar-item {
    padding-right: 3rem;
  }
  .navbar-dropdown .navbar-item {
    padding: 0.375rem 1rem;
    white-space: nowrap;
  }
  .navbar-dropdown a.navbar-item:focus,
  .navbar-dropdown a.navbar-item:hover {
    background-color: #f5f5f5;
    color: #0a0a0a;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Header.vue